module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_fruity_dried_fruit-7547ec9e.png";